// Preset specialties = the METHODS/disciplines an astrologer practises
// (NOT consultation topics like 事業/姻緣). Custom ones can be added too.
export const SPECIALTY_OPTIONS = [
  '八字', '紫微斗數', '西洋占星', '印度占星',
  '易經卜卦', '六爻', '梅花易數', '奇門遁甲',
  '風水', '塔羅牌', '姓名學', '手相', '面相', '擇日', '合婚',
];
